import { useEffect } from "react";
import "./App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Gallery } from "./components/Gallery";
import { Cities } from "./components/Cities";
import { Reviews } from "./components/Reviews";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Breadcrumb } from "./components/Breadcrumb";
import { setHomeSeo } from "./lib/seo";

export default function App() {
  useEffect(() => {
    setHomeSeo();
  }, []);

  return (
    <div className="site-shell" data-testid="homepage-shell">
      <Header />
      <main data-testid="homepage-main-content">
        <Hero />
        <Breadcrumb items={[{ label: "Início", href: "/" }, { label: "Guincho em Arujá" }]} />
        <section className="section intro-section" data-testid="institutional-intro-section">
          <div className="intro-card yellow" data-testid="intro-card-primary">
            <span data-testid="intro-card-kicker">Referência local</span>
            <h2 data-testid="intro-card-title">Auto Socorro Pedrinho: atendimento local em Arujá/SP</h2>
          </div>
          <div className="intro-text" data-testid="intro-text">
            <p data-testid="intro-paragraph-1">A Auto Socorro Pedrinho é referência em serviço de guincho e reboque em Arujá/SP. Localizada na Rod. Pres. Dutra, 199 - Jardim Real, Arujá - SP, a empresa oferece atendimento rápido, seguro e 24 horas para motoristas que precisam de guincho, reboque, transporte de veículos ou socorro mecânico.</p>
            <p data-testid="intro-paragraph-2">Se você está procurando por guincho perto de mim em Arujá, conte com uma equipe preparada para atender chamados emergenciais em bairros da cidade, na Rodovia Presidente Dutra e em regiões próximas.</p>
            <p data-testid="intro-paragraph-3">A Auto Socorro Pedrinho atende carros, motos, utilitários e outros tipos de veículos, sempre com foco em agilidade, segurança e bom atendimento.</p>
          </div>
        </section>
        <Gallery />
        <Services />
        <Cities />
        <Reviews />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}